<template>
  <pageToast :msg="msg" />
</template>

<script>
export default {
  data () {
    return {
      msg: "授权信息已失效，请重新打开！"
    }
  },
  created () {
    this.$toast.clear()
    window.sse && window.sse.close()
    let index = 0

    const timer = setInterval(() => {
      if (index < 10) {
        clearInterval(window.onlineTimer)
        clearTimeout(window.onlineTimer)
        index++
      } else {
        clearInterval(timer)
      }
    }, 1000)


  }
}
</script>

<style>
</style>
